(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function withWidth(src, width) {
    if (!src) return src;
    var absolute = src.indexOf('//') === 0 ? window.location.protocol + src : src;
    try {
      var url = new URL(absolute, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return absolute;
    }
  }

  function baseImageUrl(src) {
    if (!src) return '';
    var absolute = src.indexOf('//') === 0 ? window.location.protocol + src : src;
    try {
      var url = new URL(absolute, window.location.origin);
      url.searchParams.delete('width');
      return url.origin + url.pathname;
    } catch (error) {
      return absolute.split('?')[0];
    }
  }

  function getVariantImage(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.preview_image) {
      return variant.featured_media.preview_image.src;
    }
    if (variant.featured_image) {
      return variant.featured_image.src;
    }
    return '';
  }

  ready(function () {
    var root = document.querySelector('.ff-pdp');
    if (!root) return;

    // Trust-bar labels are defined in main-product-ff.liquid (single source of truth).

    var variantInput = document.getElementById('ff-variant-id');
    var mainImage = document.getElementById('main-img');
    if (!variantInput || !mainImage) return;

    fetch(window.location.pathname + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product JSON');
        return response.json();
      })
      .then(function (product) {
        var variants = product.variants || [];

        function syncVariantImage() {
          var selectedId = String(variantInput.value || '');
          var variant = variants.find(function (candidate) {
            return String(candidate.id) === selectedId;
          });
          var imageSrc = getVariantImage(variant);
          if (!imageSrc) return;

          mainImage.src = withWidth(imageSrc, 1200);

          var selectedBase = baseImageUrl(imageSrc);
          root.querySelectorAll('.thumb').forEach(function (thumb) {
            var thumbImage = thumb.querySelector('img');
            var isActive = thumbImage && baseImageUrl(thumbImage.src) === selectedBase;
            thumb.classList.toggle('active', Boolean(isActive));
          });
        }

        syncVariantImage();
        variantInput.addEventListener('change', syncVariantImage);

        root.querySelectorAll('.size-chip').forEach(function (chip) {
          chip.addEventListener('click', function () {
            window.setTimeout(syncVariantImage, 0);
          });
        });
      })
      .catch(function () {});
  });
})();
